import { useContext } from 'react'
import OptionsContext from 'core/OptionsContext'

export const useOptions = () => useContext(OptionsContext)

export const useFeatures = () => useOptions()[0].features

export const useTranslations = () => useOptions()[0].translations

export default useOptions
